import { useFirestoreLoaded } from '../../firebase/useFirestore'
import ActivityMeta from '../activities/ActivityMeta'
import MultiSelect from '../common/MultiSelect'
import useArrayLinkToggle from '../../hooks/useArrayLinkToggle'

/**
 * Link picker: which activities exhibit this mechanism.
 * Writes Mechanisms.Activity[] (by activity ID, not docid) — same pattern as
 * src/components/effects/SelectActivities.jsx.
 *
 * @param {object} props
 * @param {{docid: string, Activity?: string[]}} props.mechanism - The mechanism whose Activity[] link is edited.
 */
const SelectMechanismActivities = ({ mechanism }) => {
    const [activities, loaded] = useFirestoreLoaded('Activities')
    const toggleLink = useArrayLinkToggle()

    const selected = Array.isArray(mechanism.Activity) ? mechanism.Activity : []

    const toggle = (id, isSelected) => toggleLink({
        collection: 'TocMechanisms',
        docid: mechanism.docid,
        field: 'Activity',
        value: id,
        isSelected,
    })

    const options = (activities || []).map(a => ({ id: a.ID, label: a.Activity }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            loaded={loaded}
            renderSelected={(id) => <ActivityMeta id={id} inline={true} />}
            addLabel='+ Activiteit toevoegen'
            emptyLabel='Geen activiteit(en) gekoppeld'
            emptyOptionsLabel='Geen activiteiten beschikbaar'
            removeAriaLabel='Verwijder activiteit'
        />
    )
}

export default SelectMechanismActivities
